import React, { useCallback } from 'react';
import { ControlModeTemplate } from '@src/types/ControlModes';
import {
  StackModalActionType,
  StackModalState,
  StackModalAction,
} from '../../types';

export const useDialogActions = (
  state: StackModalState,
  dispatch: React.Dispatch<StackModalAction>,
  handleTemplatesSelected: (
    templates: ControlModeTemplate[],
    controlModeIndex: number,
    templateIds?: string[],
  ) => void,
) => {
  const handleOpenTemplatePicker = useCallback(
    (index: number) => {
      dispatch({
        type: StackModalActionType.OPEN_TEMPLATE_PICKER,
        payload: index,
      });
    },
    [dispatch],
  );

  const handleCloseTemplatePicker = useCallback(() => {
    dispatch({ type: StackModalActionType.CLOSE_TEMPLATE_PICKER });
  }, [dispatch]);

  const handleOpenTemplateConfirm = useCallback(
    (
      templates: ControlModeTemplate[],
      controlModeIndex: number,
      templateIds?: string[],
    ) => {
      dispatch({
        type: StackModalActionType.OPEN_TEMPLATE_CONFIRM,
        payload: { templates, controlModeIndex, templateIds },
      });
    },
    [dispatch],
  );

  const handleCloseTemplateConfirm = useCallback(() => {
    dispatch({ type: StackModalActionType.CLOSE_TEMPLATE_CONFIRM });
  }, [dispatch]);

  const handleConfirmTemplates = useCallback(() => {
    if (
      state.controlModeIndexForConfirmation !== null &&
      state.templatesForConfirmation &&
      state.templatesForConfirmation.length > 0
    ) {
      handleTemplatesSelected(
        state.templatesForConfirmation,
        state.controlModeIndexForConfirmation,
        state.templateIdsForConfirmation,
      );
      dispatch({ type: StackModalActionType.CLOSE_TEMPLATE_CONFIRM });
    }
  }, [
    state.controlModeIndexForConfirmation,
    state.templatesForConfirmation,
    state.templateIdsForConfirmation,
    handleTemplatesSelected,
    dispatch,
  ]);

  const handleOpenDeleteConfirm = useCallback(
    (index: number) => {
      dispatch({
        type: StackModalActionType.OPEN_DELETE_CONFIRM,
        payload: index,
      });
    },
    [dispatch],
  );

  const handleCloseDeleteConfirm = useCallback(() => {
    dispatch({ type: StackModalActionType.CLOSE_DELETE_CONFIRM });
  }, [dispatch]);

  return {
    handleOpenTemplatePicker,
    handleCloseTemplatePicker,
    handleOpenTemplateConfirm,
    handleCloseTemplateConfirm,
    handleConfirmTemplates,
    handleOpenDeleteConfirm,
    handleCloseDeleteConfirm,
  };
};
